/* istanbul ignore file */
import _ from 'underscore';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { ConversionRateAdjustmentView } from '@bingads-webui-campaign/conversion-rate-adjustment';

export function ConversionRateInlineEditableColumnPrompt({
  item,
  newPosition,
  i18n,
  fieldName,
  saveModel,
}) {
  const conversionRateAdjustmentView = new ConversionRateAdjustmentView({
    value: item.AdjustmentPercentage,
    i18n,
  });

  const editorView = new GridCustomizedPopupEditor({
    editorView: conversionRateAdjustmentView.render(),
    cellPosition: newPosition,
    tableContainer: '.bingadsgrid',
    parentContainerSelector: '.grid-and-disclaim-container',
  }).render();

  editorView.on('close', (model) => {
    const changed = model && (item.AdjustmentPercentage !== model.AdjustmentPercentage);
    if (changed) {
      const updated = _.extendOwn({}, item);
      updated[fieldName] = model.AdjustmentPercentage;
      saveModel(updated, conversionRateAdjustmentView);
    }
  });
}
